/**
 * Posição do botão flutuante "Registrar": guardada como distância das bordas direita/inferior,
 * para continuar ancorada no canto quando a janela muda de tamanho.
 */

export interface FabOffset {
  right: number;
  bottom: number;
}

export const FAB_DEFAULT_OFFSET: FabOffset = { right: 22, bottom: 22 };
export const FAB_STORAGE_KEY = 'mai.registerFab.offset.v1';
/** Abaixo disso o gesto é clique, não arraste. */
export const FAB_DRAG_THRESHOLD_PX = 5;

const MARGIN = 8;

/** Mantém o botão inteiro dentro da janela, com uma margem mínima. */
export function clampFabOffset(
  offset: FabOffset,
  viewport: { width: number; height: number },
  size: { width: number; height: number },
): FabOffset {
  const maxRight = Math.max(MARGIN, viewport.width - size.width - MARGIN);
  const maxBottom = Math.max(MARGIN, viewport.height - size.height - MARGIN);
  return {
    right: Math.round(Math.min(Math.max(offset.right, MARGIN), maxRight)),
    bottom: Math.round(Math.min(Math.max(offset.bottom, MARGIN), maxBottom)),
  };
}

export function parseFabOffset(raw: string | null | undefined): FabOffset | null {
  if (!raw) return null;
  try {
    const v = JSON.parse(raw);
    if (v && Number.isFinite(v.right) && Number.isFinite(v.bottom)) return { right: v.right, bottom: v.bottom };
  } catch {
    /* valor antigo ou corrompido: volta ao canto padrão */
  }
  return null;
}

export function loadFabOffset(): FabOffset | null {
  try {
    return parseFabOffset(window.localStorage.getItem(FAB_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function saveFabOffset(offset: FabOffset | null): void {
  try {
    if (offset) window.localStorage.setItem(FAB_STORAGE_KEY, JSON.stringify(offset));
    else window.localStorage.removeItem(FAB_STORAGE_KEY);
  } catch {
    /* modo privado / storage bloqueado: a posição vale só nesta sessão */
  }
}
